export default "__VITE_ASSET__Zn8FyRCU__"